var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-translate';
import { actions as articlesActions } from '../redux/articles';
import ArticleSourceSelector from '../components/ArticleSourceSelector';
import ArticleList from '../components/ArticleList';
import ArticleLayers from './ArticleLayers';
import { provideMapState } from 'react-openlayers';
import { getSource, getActiveSources, loadArticlesIfNeeded } from '../utils/knreise';
import { getArticles } from '../utils/article';
import { ensureArticleModuleConfig } from '../hocs/ensureArticleModuleConfig';
import './Articles.scss';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, articlesActions), dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    articles: state.articles.articles,
    articleLoadState: state.articles.loadState,
    articlesLoading: state.articles.loading
  };
};

export var Articles = (_temp = _class = function (_React$Component) {
  _inherits(Articles, _React$Component);

  function Articles() {
    _classCallCheck(this, Articles);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Articles.prototype.componentDidMount = function componentDidMount() {
    this.checkSources(this.props);
  };

  Articles.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkSources(nextProps);
  };

  Articles.prototype.componentDidUpdate = function componentDidUpdate() {
    this.props.onContentChange && this.props.onContentChange();
  };

  Articles.prototype.checkSources = function checkSources(props) {
    if (props.preventLoad) return;
    this.activeSources.forEach(function (source) {
      var loadState = props.articleLoadState[source];
      var mapCenter = props.mapCenter,
          mapZoom = props.mapZoom,
          mapExtent = props.mapExtent,
          projCode = props.projCode,
          filterColumns = props.filterColumns,
          pageLimit = props.pageLimit,
          loadSource = props.loadSource;
      loadArticlesIfNeeded(source, loadState, mapCenter, mapZoom, mapExtent, projCode, filterColumns, pageLimit, loadSource);
    });
  };

  Articles.prototype.render = function render() {
    var _props = this.props,
        hideSelector = _props.hideSelector,
        hideLayers = _props.hideLayers,
        onSourceSelect = _props.onSourceSelect,
        onArticleOpen = _props.onArticleOpen,
        useActiveStyle = _props.useActiveStyle,
        useHoverStyle = _props.useHoverStyle,
        sourceSelectorPlaceholder = _props.sourceSelectorPlaceholder,
        thumbnailClassName = _props.thumbnailClassName,
        thumbnailSize = _props.thumbnailSize,
        sources = _props.sources,
        featureLimit = _props.featureLimit,
        articleLimit = _props.articleLimit,
        openArticleId = _props.openArticleId,
        lazyLoad = _props.lazyLoad,
        articlesLoading = _props.articlesLoading,
        articleComponent = _props.articleComponent,
        filterColumns = _props.filterColumns;
    var activeSources = this.activeSources;
    var articles = this.articles;
    return React.createElement('div', {
      className: 'articles--container'
    }, !hideLayers && React.createElement(ArticleLayers, {
      articles: articles,
      activeSources: activeSources,
      onArticleOpen: onArticleOpen,
      openArticleId: openArticleId,
      useActiveStyle: useActiveStyle,
      useHoverStyle: useHoverStyle,
      featureLimit: featureLimit,
      sources: sources,
      filterColumns: filterColumns
    }), !hideSelector && React.createElement(ArticleSourceSelector, {
      className: 'articles--selector',
      sources: sources,
      getSource: getSource,
      activeSources: activeSources,
      onSelect: onSourceSelect,
      placeholder: sourceSelectorPlaceholder
    }), React.createElement(ArticleList, {
      articles: articles.slice(0, articleLimit),
      onArticleOpen: onArticleOpen,
      thumbnailClassName: thumbnailClassName,
      thumbnailSize: thumbnailSize,
      lazyLoad: lazyLoad,
      isLoading: articlesLoading,
      articleComponent: articleComponent
    }));
  };

  _createClass(Articles, [{
    key: 'articles',
    get: function get() {
      var _props2 = this.props,
          articles = _props2.articles,
          mapCenter = _props2.mapCenter,
          projCode = _props2.projCode;
      var activeSources = this.activeSources;

      if (!mapCenter) {
        return [];
      }

      return getArticles(articles, activeSources, mapCenter, projCode);
    }
  }, {
    key: 'activeSources',
    get: function get() {
      var _props3 = this.props,
          activeSources = _props3.activeSources,
          sources = _props3.sources;
      return getActiveSources(activeSources, sources);
    }
  }]);

  return Articles;
}(React.Component), _class.defaultProps = {
  filterColumns: {},
  activeSources: [],
  articleLimit: 20
}, _temp);
Articles.propTypes = process.env.NODE_ENV !== "production" ? {
  activeSources: PropTypes.array,
  loadSource: PropTypes.func.isRequired,
  lazyLoad: PropTypes.bool,
  articlesLoading: PropTypes.bool,
  articleLoadState: PropTypes.object,
  articles: PropTypes.object,
  thumbnailClassName: PropTypes.string,
  thumbnailSize: PropTypes.string,
  hideSelector: PropTypes.bool,
  hideLayers: PropTypes.bool,
  preventLoad: PropTypes.bool,
  onSourceSelect: PropTypes.func,
  onContentChange: PropTypes.func,
  onArticleOpen: PropTypes.func.isRequired,
  mapCenter: PropTypes.any,
  mapZoom: PropTypes.number,
  mapExtent: PropTypes.array,
  projCode: PropTypes.string,
  useActiveStyle: PropTypes.bool,
  useHoverStyle: PropTypes.bool,
  sourceSelectorPlaceholder: PropTypes.func,
  sources: PropTypes.array.isRequired,
  articleComponent: PropTypes.func,
  featureLimit: PropTypes.number,
  articleLimit: PropTypes.number,
  filterColumns: PropTypes.object,
  openArticleId: PropTypes.string,
  pageSize: PropTypes.number
} : {};
export default translate('Articles')(connect(mapStateToProps, mapDispatchToProps)(ensureArticleModuleConfig(provideMapState(Articles))));